import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// Resolved by Generator::SubscriptionState rather than matched against a tier list here: the
// entitlement no longer follows from studioAccessTier alone, since a migrated free trial keeps
// tier 'in_free_beta' while holding premium access for as long as its credits last.
function useDccBridgeAccess() {
  const premiumFeatures = useThreeDStudioStore((state) => state.subscription.premiumFeatures)
  return premiumFeatures === true
}

export default useDccBridgeAccess
